module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if (!isHidden && canEdit) { 
__p+='\r\n<td rowspan="'+
((__t=( groupSize ))==null?'':__t)+
'" style="vertical-align:bottom;" class="table-splitted">\r\n    <button type="button" class="btn btn-primary btn-sm add-event">Add event</button>\r\n</td>\r\n';
 } 
__p+='\r\n<td hidden>'+
((__t=( medicationId ))==null?'':__t)+
'</td>\r\n<td>'+
((__t=( name ))==null?'':__t)+
'</td>\r\n<td>'+
((__t=( eventTypeName ))==null?'':__t)+
'</td>\r\n<td>\r\n    ';
 if ((diseasesUuids || []).length != 0) { 
__p+='\r\n    <div class="diseases-show center clickable" title="Diseases">\r\n        <span class="badge">'+
((__t=( (diseasesUuids || []).length ))==null?'':__t)+
'</span>\r\n    </div>\r\n    ';
 } 
__p+='\r\n</td>\r\n<td hidden>'+
((__t=( systemType ))==null?'':__t)+
'</td>\r\n<td>'+
((__t=( formName ))==null?'':__t)+
'</td>\r\n<td>'+
((__t=( dose ))==null?'':__t)+
'</td>\r\n<td>'+
((__t=( quantity ))==null?'':__t)+
'</td>\r\n<td>\r\n    '+
((__t=( (frequency || {}).title ))==null?'':__t)+
'\r\n    ';
 if (regularFrequency){
__p+=' - '+
((__t=( regularFrequency.title ))==null?'':__t)+
' ';
}
__p+='\r\n</td>\r\n<td>'+
((__t=( startDate ))==null?'':__t)+
'</td>\r\n<td>'+
((__t=( stopDate ))==null?'':__t)+
'</td>\r\n<td>\r\n    ';
 if ((documentsIds || []).length != 0) { 
__p+='\r\n    <div class="documents-show center clickable" title="Documents">\r\n        <span class="badge">'+
((__t=( (documentsIds || []).length ))==null?'':__t)+
'</span>\r\n    </div>\r\n    ';
 } 
__p+='\r\n</td>\r\n<td class="col-md-2 col-xs-2">'+
((__t=( comment ))==null?'':__t)+
'</td>\r\n<td><span class="clickable glyphicon glyphicon glyphicon-pencil edit" title="Edit"></span></td>\r\n<td><span class="clickable glyphicon glyphicon-remove remove" title="Remove"></span></td>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/medicals/medication.html
// module id = 354
// module chunks = 0